import React, { useState, useRef, useEffect } from "react";
import DashboardContent from "../../components/DashboardContent";
import TicketsTable from "../Tickets";
// import { ticketsData } from "../Tickets";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Button from "../../components/button";
import "./Dashboard.scss";
import { useNavigate } from "react-router";
import { useTicketsAnalytics } from "../../hooks/useTicketsAnalytics";
import { isPermit } from "../../utils/permissionCheck";
import PermissionDenied from "../OtherPage/PermissionDenied";
import { Dayjs } from "dayjs";
gsap.registerPlugin(ScrollTrigger);

const App: React.FC = () => {
  const headerHeight = 64;
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);
  const ticketsRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [selectedPeriod, setSelectedPeriod] = useState<[Dayjs, Dayjs] | any>(
    null
  );
  const navigate = useNavigate();
  const selectedFilter = 1; // Set this to the appropriate filter value
  const { data: analytics, isLoading } = useTicketsAnalytics(
    selectedPeriod
      ? `${selectedPeriod[0].format("MM-YYYY")} - ${selectedPeriod[1].format(
          "MM-YYYY"
        )}`
      : "02-2024 - 05-2025"
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Parallax effect
  useEffect(() => {
    if (ticketsRef.current && wrapperRef.current) {
      gsap.fromTo(
        ticketsRef.current,
        { y: 500 },
        {
          y: 0,
          ease: "none",
          scrollTrigger: {
            trigger: wrapperRef.current,
            start: "top top",
            end: "bottom top",
            scrub: true,
          },
        }
      );
    }
  }, []);

  return (
    <>
      {isPermit(1, "view") ? (
        <>
          <div
            className="dashboard-frame"
            ref={wrapperRef}
            style={{ position: "relative" }}
          >
            <div
              style={{
                position: "fixed",
                top: headerHeight,
                left: 0,
                width: "100%",
                zIndex: 1,
              }}
            >
              <DashboardContent
                isLoading={isLoading}
                analytics={analytics}
                selectedPeriod={selectedPeriod}
                onPeriodChange={setSelectedPeriod}
              />
            </div>

            {/* Tickets scrolls on top */}
            <div
              ref={ticketsRef}
              style={{
                position: "relative",
                zIndex: 2,
              }}
              className="tickets-wrapper"
            >
              <TicketsTable
                pagination={false}
                isMobile={isMobile}
                // dataSource={ticketsData.slice(0, 10)}
                scroll={{ x: 1400, y: 300 }}
              />

              <div className="button-wrapper flex justify-center">
                <Button
                  onClick={() => navigate("/tickets")}
                  className="ant-btn-tertiary"
                >
                  View all
                </Button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <PermissionDenied />
      )}
    </>
  );
};

export default App;
